// ---- DEV NOTE: must match with CSS (scss/main/_variables.scss and scss/inc/mixins) ----- //
export default {
  breakpoints: {
    bs: {
      'xs': 0,
      'sm': 576,
      'md': 768,
      'lg': 992,
      'xl': 1200,
      'xxl': 1400
    },
    aggreko: {
      'small': 576,
      'medium': 992,
      'medium-large': 1200,
      'large': 1400,
      'larger': 1630
    }
  }
};